<template>
  <div class="" id="regist">
    <header style="position: fixed;">
      <div class="inner">
        <router-link to="/">首页</router-link>
      </div>
    </header>
    <div class="registbox">
      <el-form :model="ruleForm" :label-position="labelPosition" status-icon :rules="rules" ref="ruleForm"
        label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="公司" prop="company">
          <el-input type="tel" v-model="ruleForm.company" placeholder="请输入公司" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item> -->
       <!-- <el-form-item label="部门" prop="department">
          <el-input type="tel" v-model="ruleForm.department" placeholder="请输入部门" autocomplete="off"
            class="myrulesinput">
          </el-input>
        </el-form-item> -->
        <el-form-item label="账号" prop="account">
          <el-input type="text" v-model="ruleForm.account" placeholder="请输入账号" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" autocomplete="off"
            class="myrulesinput" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入密码" autocomplete="off"
            class="myrulesinput" show-password></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input type="text" v-model="ruleForm.name" placeholder="请输入姓名" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input type="tel" v-model="ruleForm.tel" placeholder="请输入电话" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
       <!-- <el-form-item label="职位" prop="is_leader">
          <el-select v-model="ruleForm.is_leader" placeholder="请选择" class="myrulesinput" popper-class='select'>
            <el-option v-for="item in options" :key="item.id" :label="item.values" :value="item.values"
              :disabled="item.disabled">
              <span style=" color: #8492a6; font-size: 0.8125rem;" class="myrulesinput">{{ item.values }}</span>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="upload()">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    RegisterView
  } from '../../static/API/API.js'
  export default {
    name: 'regist',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validatetel = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入电话'));
        } else {
          if (this.ruleForm.tel !== '') {
            this.$refs.ruleForm.validateField('tel');
          }
          callback();
        }
      };
      var validateusername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          if (this.ruleForm.username !== '') {
            this.$refs.ruleForm.validateField('username');
          }
          callback();
        }
      };
      var validatenames = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入姓名'));
        } else {
          if (this.ruleForm.name !== '') {
            this.$refs.ruleForm.validateField('name');
          }
          callback();
        }
      };
      return {
        show: false,
        department: '',
        options: [{
            values: '部门经理'
          },
          {
            values: '部门成员'
          }
        ],
        value: '',
        option2: [],
        value2: '',
        sizeForm: {
          user: '',
          pwd: '',
        },
        drawer: false,
        direction: 'btt',
        labelPosition: 'left',
        ruleForm: {
          company: '', //公司
          department: '', //部门
          account: '', //账号
          password: '', //密码
          name: '', //姓名
          tel: '', //电话
          checkPass: '', //验证密码
          is_leader: '' //是否为部门领导:0为普通员工,1位领导
        },
        rules: {
          account: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          name: [{
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            },
            {
              min: 2,
              max: 5,
              message: '长度在 2 到 5 个字符',
              trigger: 'blur'
            }
          ],
          password: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }],
          tel: [{
            required: true,
            message: '请输入电话号',
            trigger: 'blur'
          }],
          company: [{
            required: true,
            message: '请输入公司',
            trigger: 'blur'
          }],
          positions: [{
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          }],
          department: [{
            required: true,
            message: '请输入部门',
            trigger: 'blur'
          }],
        },
        setIH: [], //各平台的跳转链接

      }
    },
    mounted() {

    },
    methods: {
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      upload() {
        let formModels = this.ruleForm
        let roles = formModels.department
        let params = new URLSearchParams();
        params.append('company', '上海孜益供应链科技有限公司'); //公司名字
        params.append('name', formModels.name); //注册人
        params.append('tel', formModels.tel); //注册电话
        params.append('account', formModels.account); //管理员账号
        params.append('password', formModels.password); //管理员密码
        params.append('department', '未授权'); //管理员部门
        params.append('is_leader', 0);
        // if (formModels.is_leader == '领导') {
        //   params.append('is_leader', 1); //领导身份
        // } else {
        //   params.append('is_leader', 0); //成员身份
        // }
        this.$axios.post(RegisterView, params).then(res => {
          this.$notify.info({
            title: '消息',
            message: res.data
          });
          setTimeout(function() {
            // window.location.href = 'http://www.ziyichain.cn/';
            this.$router.push('/')
          }, 3000)
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.show = false
        this.ruleForm.department = ''
      },
    }
  }
</script>

<style scoped>
  .select{
    width: 25rem !important;
  }
  .el-form,
  .el-form--label-left {
    margin-top: 35%;
    width: 25rem;
  }

  .el-select-dropdown {
    max-width: 2.5rem;
    width: 25rem;
    transform-origin: center top;
    z-index: 2009;
    position: absolute;
    top: 28.5625rem;
    left: 57.25rem
  }

  .el-select-dropdown__item {
    overflow: visible;
  }

  #regist {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
    background: url(../../static/images/right.jpg) no-repeat !important;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/regist.vue